
import './element.matches.polyfill';
import './menu';
import './base-slider';


if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof window.DocumentTouch)) {
  document.documentElement.classList.add('is-touch');
}



// WEBPACK FOOTER //
// ./src/js/main.js